module.exports = __webpack_public_path__ + "img/youdubook.6f35ee93.png";